import React, { useState } from "react";
import Modal from "react-responsive-modal";
import img1 from "../../assets/newImages/Group 1399.png";
import img3 from "../../assets/newImages/Group 1403.png";
import img2 from "../../assets/newImages/Illustration.png";
import { FaStar } from "react-icons/fa";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import GoogleAuthentication from "../../components/SocialAuthentication/GoogleSocialAuth";
import Input from "../../components/Input/InputComponent";
import { useHistory } from "react-router-dom";
import Button from "../EmptyButton";
import { apiRequest, getApiKey, setKey, setUser } from "../../helpers";
import { GetUserInfo } from "../../services";
import { createErrorAlert } from "../../redux/actions";
import { useDispatch } from "react-redux";

const validateSchema = Yup.object({
  email: Yup.string().email("Invalid email").required("Email is required"),
  first_name: Yup.string()
    .required("First Name is required")
    .min(5, "Minimum 5 characters")
    .max(26, "Maximum 26 characters"),
  password2: Yup.string().oneOf([Yup.ref("password1"), null], "Passwords must match"),
  password1: Yup.string()
    .required("Password is required.")
    .min(7, "Password is too short - should be 6+ chars minimum.")
    .matches(
      /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/,
      "Password should have at least one capital letter & one digit."
    ),
});

const SignUpModal = ({
  open,
  onClose,
  setSignupModal,
  login,
  redirectAfterLogin,
  onAuthenticated,
  role,
  focusTrapped,
  blockScroll,
  closeOnOverlayClick,
  labelledBy,
  describedBy,
  center,
  style,
  classNames,
  showCloseIcon,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [checkBox, setCheckBox] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  const checked = (value) => {
    setCheckBox(value);
  };

  const onSignUp = async (values) => {
    if (checkBox !== true) {
      dispatch(createErrorAlert(201, "Error", "Please agree to the terms and conditions", 201));
      return;
    }

    await apiRequest({
      method: "post",
      url: `accounts/dj-rest-auth/registration`,
      data: values,
    })
      .then(async (res) => {
        setKey(res.data.access_token);
        setSignupModal(false);
        if (getApiKey()) {
          if (onAuthenticated) {
            const userData = await GetUserInfo();
            setUser(JSON.stringify(userData));
            onAuthenticated(userData);
          } else if (redirectAfterLogin) {
            const userData = await GetUserInfo();
            setUser(JSON.stringify(userData));
            const separator = redirectAfterLogin.includes("?") ? "&" : "?";
            history.push(`${redirectAfterLogin}${separator}user_id=${userData.id}`);
          } else {
            window.location.reload();
          }
        }
      })
      .catch((err) => {
        let errorResponse;
        for (const key in err.response.data) {
          if (
            err.response.data.hasOwnProperty(key) &&
            Array.isArray(err.response.data[key]) &&
            err.response.data[key].length > 0
          ) {
            errorResponse = err.response.data[key][0];
          }
        }
        dispatch(createErrorAlert(400, "", errorResponse, 400));
      });
  };

  return (
    <Modal
      role={role}
      open={open}
      onClose={onClose}
      focusTrapped={focusTrapped}
      blockScroll={blockScroll}
      closeOnOverlayClick={closeOnOverlayClick}
      showCloseIcon={showCloseIcon !== false}
      aria-labelledby={labelledBy}
      aria-describedby={describedBy}
      center={center}
      styles={{ style }}
      classNames={classNames}
    >
      <div className="flex gap-4">
        <div className="w-full hidden md:block">
          <p className="text-body-large  font-bold text-left md:text-h3 xl:text-36  mr-1">
            Join the movement of{" "}
            <span className="text-yellowish">26K savvy StudyCrowd.AI members</span>{" "}
            already empowered - and you're next
          </p>

          <p className=" text-body-small text-left pt-6 pr-2 md:text-h5 pr-2 xl:text-36 ">
            Discover the secret to success as you become part of our growing community.
          </p>
          <p className="text-body-small text-left pt-6 pr-2 md:text-h5 pr-2 xl:text-36 ">
            Find simple and concise study resources created by top graduates who took the
            same courses as you at US and UK universities
          </p>
          <div className="flex justify-around mt-10 items-center flex-col lg:flex-row">
            <div className=" text-center">
              <div className="w-150 h-150">
                <img src={img2} className="m-auto mt-3 w-full h-full" />
              </div>
              <p className="fw-bold text-42  text-yellowish">50K+</p>
              <p>
                Active Users
                <br />
                in 2025
              </p>
            </div>
            <div className=" text-center">
              <div className="w-150 h-150">
                <img src={img3} className="m-auto mt-3 w-full h-full" />
              </div>
              <p className="fw-bold text-42  text-yellowish">2000+</p>
              <p className="h-51">
                Tutoring Hours and Career
                <br />
                Mentoring Hours <br />
                Delivered
              </p>
            </div>
          </div>
          <div
            className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-16"
            style={{ borderColor: "#f7f7f7" }}
          >
            <a
              href="https://www.reviews.co.uk/company-reviews/store/www.simplestudying.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ borderColor: "#f7f7f7" }}
              className="flex items-center justify-center space-x-3 p-4 bg-white rounded-lg border border hover:bg-white transition-colors cursor-pointer"
            >
              <FaStar className="w-6 h-6 text-primary" />
              <div className="text-left">
                <div className="font-bold text-foreground">4.6/5</div>
                <div className="text-sm text-muted-foreground">Rating on Reviews.io</div>
              </div>
            </a>

            <a
              href="https://g.co/kgs/94X3PU6"
              target="_blank"
              rel="noopener noreferrer"
              style={{ borderColor: "#f7f7f7" }}
              className="flex items-center justify-center space-x-3 p-4 bg-white rounded-lg border border-white hover:bg-white transition-colors cursor-pointer"
            >
              <FaStar className="w-6 h-6 text-primary" />
              <div className="text-left">
                <div className="font-bold text-foreground">4.9/5</div>
                <div className="text-sm text-muted-foreground">Rating on Google</div>
              </div>
            </a>
          </div>
          <div
            className="grid grid-cols-1 md:grid-cols-1 font-bold text-center gap-6 mt-16"
            style={{ borderColor: "#f7f7f7" }}
          >
            <p className="text-sm text-muted-foreground">
              Free to join • No credit card required • Instant access
            </p>
          </div>
        </div>

        <div>
          <Formik
            initialValues={{
              password1: "",
              first_name: "",
              email: "",
              password2: "",
            }}
            validationSchema={validateSchema}
            onSubmit={(values) => onSignUp(values)}
          >
            {({ isValid, handleSubmit, values, setFieldValue }) => (
              <Form>
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="flex flex-col text-darkest items-center">
                    <p className="loginHeadText text-darkest font-bold text-body-large mb-10 md:text-h3 xl:text-36 text-center">
                      Sign in to <span className="text-yellowish">StudyCrowd.AI</span>
                    </p>
                    <div className="w-full mb-3 md:mb-9 ">
                      <GoogleAuthentication redirectAfterLogin={redirectAfterLogin} />
                      <p className="mb-8 mt-16">Email</p>
                      <Field
                        name="email"
                        as={Input}
                        placeholder="Enter your email"
                        type="text"
                        onChange={(e) => {
                          const email = e.target.value;
                          const username = email.split("@")[0];
                          setFieldValue("email", email);
                          setFieldValue("username", username);
                        }}
                      />
                    </div>

                    <div className="w-full mb-3 md:mb-9 ">
                      <p className="mb-8">First Name</p>
                      <Field name="first_name" as={Input} placeholder="Enter your First Name" type="text" />
                    </div>

                    <div className="w-full ">
                      <p className="mb-8">Password</p>
                      <Field
                        name="password1"
                        as={Input}
                        placeholder="Enter your password"
                        type={showPassword ? "text" : "password"}
                        setShowPassword={setShowPassword}
                        showPassword={showPassword}
                        inputType="password"
                      />
                      <p className="text-small text-darkGrey2 my-8">6+ characters, 1 capital letter </p>
                    </div>
                    <div className="w-full mb-10 md:mb-14">
                      <p className="mb-8">Confirm password</p>
                      <Field
                        name="password2"
                        as={Input}
                        placeholder="Enter your confirm password"
                        type={showConfirmPassword ? "text" : "password"}
                        setShowPassword={setShowConfirmPassword}
                        showPassword={showConfirmPassword}
                        inputType="password"
                      />
                    </div>
                    <div className="w-full mb-10 md:mb-14" style={{ display: "flex" }}>
                      <label htmlFor="condBox" className="condContainer">
                        {" "}
                        I agree to{" "}
                        <a style={{ color: "#cc6828", cursor: "pointer" }} href="/terms-conditions" target="_blank">
                          Terms and Conditions
                        </a>
                        ,{" "}
                        <a style={{ color: "#cc6828", cursor: "pointer" }} href="/privacy-policy" target="_blank">
                          Privacy Policy
                        </a>{" "}
                        and{" "}
                        <a style={{ color: "#cc6828", cursor: "pointer" }} href="/cookies-policy" target="_blank">
                          Cookies Policy
                        </a>{" "}
                        of Simple Studying{" "}
                        <input
                          id="condBox"
                          onClick={(e) => checked(e.target.checked)}
                          type="checkbox"
                          className="default:ring-2 text-primary mr-3 checkBoxOne"
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                  <div className="pt-4 flex justify-center mb-10">
                    <div className="w-full h-51">
                      <Button
                        onClick={handleSubmit}
                        text="Sign up for free"
                        filled
                        className="buttonClass"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleSubmit();
                        }}
                        disabled={
                          values.first_name === "" ||
                          values.password1 === "" ||
                          values.password2 === "" ||
                          values.email === "" ||
                          !isValid ||
                          values.checked === "false"
                        }
                      />
                    </div>
                  </div>
                </form>
              </Form>
            )}
          </Formik>
        </div>
      </div>

      <p className="font-normal text-darkest font-body-large text-center">
        Already have an account?{" "}
        <a
          className="font-bold text-primary cursor-pointer"
          onClick={() => {
            login(true);
            setSignupModal(false);
          }}
        >
          {"  "}Log in
        </a>
      </p>
    </Modal>
  );
};

export default SignUpModal;
